import type {} from "@lit/react";
import { UploadFileList as UploadFileListElement, } from "@vaadin/upload/vaadin-upload-file-list.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { UploadFileListElement, };
export type UploadFileListEventMap = Readonly<{}>;
const events = {} as UploadFileListEventMap;
export type UploadFileListProps = WebComponentProps<UploadFileListElement, UploadFileListEventMap>;
export const UploadFileList = createComponent({
    elementClass: UploadFileListElement, events, react: React, tagName: "vaadin-upload-file-list"
});
